import Head from 'next/head';
import { Footer, Header } from '../../components';
import previewMain from '../../public/preview/preview-main.png';
import menu from '../../utils/menu';
import Team from './team';

export default function TeamPage() {
  return (
    <>
      <Head>
        <title>
          Meet the Mavinx Team: Passionate Experts Driving Innovation and
          Success
        </title>
        <meta
          property="og:title"
          content="Meet the Mavinx Team: Passionate Experts Driving Innovation and Success"
        />
        <meta property="og:image" content={`${previewMain.src}`} />
        <meta name="twitter:image" content={`${previewMain.src}`} />
        <meta
          property="og:image:alt"
          content="Meet the Mavinx Team: Passionate Experts Driving Innovation and Success"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="Meet the creative and dedicated Mavinx team that innovates and delivers effective solutions for our customers. Explore our online and mobile app developers, designers, marketers, project managers, and more. Learn about our customer-centric mentality, collaborative approach, and dedication to excellence. Discover how our team's talents and passion help our customers' projects succeed, providing high-quality outputs and customer satisfaction."
        />

        <meta
          name="description"
          content="Meet the creative and dedicated Mavinx team that innovates and delivers effective solutions for our customers. Explore our online and mobile app developers, designers, marketers, project managers, and more. Learn about our customer-centric mentality, collaborative approach, and dedication to excellence. Discover how our team's talents and passion help our customers' projects succeed, providing high-quality outputs and customer satisfaction."
        />
        <meta
          name="keywords"
          content="Mavinx team, meet the team, passionate experts, innovation, success, web developers, mobile app developers, designers, marketers, project managers, collaborative approach, customer-centric, commitment to excellence, skills, dedication, top-quality deliverables, customer satisfaction, collaboration, expertise, business goals"
        />
      </Head>
      <Header appearance="transparent" appearanceLogo="primary" menu={menu} />
      <Team />
      <Footer />
    </>
  );
}
